import { useState, useCallback } from 'react';
import './App.css';
import Earth3D from './components/Earth3D';

function App() {
  const [satelliteData, setSatelliteData] = useState({ count: 0, loading: true });
  const currentMonth = new Date().toLocaleString('default', { month: 'long', year: 'numeric' });

  const handleSatellitesLoaded = useCallback((data) => {
    setSatelliteData(data);
  }, []);

  return (
    <div className="App">
      {/* Hero Section */}
      <section className="hero">
        <div className="stars"></div>
        <div className="shooting-stars"></div>
        <Earth3D onSatellitesLoaded={handleSatellitesLoaded} />

        {/* Satellite Info Panel */}
        <div className="satellite-panel">
          <div className="satellite-panel-title">LAUNCHES: {currentMonth.toUpperCase()}</div>
          {satelliteData.loading ? (
            <div className="satellite-panel-loading">Loading TLE data...</div>
          ) : (
            <>
              <div className="satellite-panel-row">
                <span className="satellite-dot leo">●</span> LEO Satellites
              </div>
              <div className="satellite-panel-count">
                Tracking: <span className="satellite-count-number">{satelliteData.count}</span> objects
              </div>
            </>
          )}
        </div>

        <div className="hero-content">
          <h1 className="hero-headline">Building Web Applications<br />for the Aerospace Industry</h1>
          <div className="hero-author">
            <span className="author-name">Dominik Coll</span>
            <span className="author-divider">—</span>
            <span className="author-role">Web Application Developer</span>
          </div>
          <p className="hero-tagline">Three.js • React • Mission Visualization</p>
        </div>
      </section>

    </div>
  );
}

export default App;
